import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { ROUTES } from 'helpers/constants'
import { useAuthState } from 'hooks'

import AdminPortal from 'pages/admin/AdminPortal'
import AdminMatches from 'pages/admin/AdminMatches'
import AdminActiveUsers from 'pages/admin/AdminActiveUsers'
import AdminUser from 'pages/admin/AdminUser'
import AdminWaitlist from 'pages/admin/AdminWaitlist'
import AdminUserAI from 'pages/admin/AdminUserAI'
import AdminAnalytics from 'pages/admin/AdminAnalytics'

const Admin = () => {
  const { user } = useAuthState()

  if (!user?.admin) {
    return null
  }

  return (
    <Switch>
      <Route component={AdminWaitlist} path={ROUTES.ADMIN_WAITLIST} />
      <Route component={AdminActiveUsers} path={ROUTES.ADMIN_ACTIVE_USERS} />
      <Route component={AdminMatches} path={ROUTES.ADMIN_MATCHES} />
      <Route component={AdminUserAI} path={ROUTES.ADMIN_USER_AI} />
      <Route component={AdminUser} path={ROUTES.ADMIN_USER} />
      <Route component={AdminAnalytics} path={ROUTES.ADMIN_ANALYTICS} />
      <Route component={AdminPortal} />
    </Switch>
  )
}

export default Admin
